import styled from 'styled-components';

export const LoginContainer = styled.form`
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;

export const NavContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-right: 10px;
`;

export const HeaderContainer = styled.div`
  margin-top: 6px;
  display: flex;
  justify-content: space-between;
`;

export const BodyContainer = styled.div`
  width: 80%;
  margin: auto;
`;